import { 
  WorkflowStatus,
  DevModeStyle,
  TestModeStyle,
  getStatusConfig
} from '../utils/enums';

export const StatusBadge = ({ status, label = "", className }) => {
  // Get style properties (bgColor, textColor, borderColor) from central config
  const config = getStatusConfig(status);

  return (
    <span
      className={`text-[11px] rounded-full px-3 py-0 m-0 font-bold border uppercase tracking-wide inline-block transition-colors
        ${config.bgColor} 
        ${config.textColor} 
        ${config.borderColor}
        ${className || ""}
      `}
    >
      {/* Use label if provided, otherwise show status text, default to Pending */}
      {label || status || WorkflowStatus.PENDING}
    </span>
  );
};

export const DevModeBadge = ({ label = "DEV MODE" }) => {
  return (
    <span
      className={`text-sm rounded-xl px-3 py-1 m-0 font-bold ${
        DevModeStyle
      }`}
    >
      {label}
    </span>
  );
};

export const TestModeBadge = ({ label = "TEST MODE" }) => {
  return (
    <span
      className={`text-sm rounded-xl px-3 py-1 m-0 font-bold ${
        TestModeStyle
      }`}
    >
      {label}
    </span>
  );
};